import { Text } from '@ayble-health/dashboard-components';
const MindGutContentPreview = () => {
  return <Text textAlign={'center'}>placeholder</Text>;
};

export default MindGutContentPreview;
